export enum ApplicationStatusOptions {
	INITIALIZING = 'initializing',
	INITIALIZED = 'initialized',
	FETCHING = 'fetching',
	READY = 'ready',
	ERROR = 'error',
}
